import { formatMoney } from '@/shared/utils/money';
import type { AdminSubscriptionMonitorItem } from '../types/adminSubscription';

export const EXPIRING_SOON_DAYS = 7;

export interface MonitorKpis {
  total: number;
  active: number;
  trialing: number;
  expiredOrSuspended: number;
  paymentIssues: number;
  expiringSoon: number;
}

export function isExpiringSoon(item: AdminSubscriptionMonitorItem): boolean {
  const days = item.days_remaining;
  if (days === null || days < 0) return false;
  if (item.subscription_status === 'trialing' || item.subscription_status === 'active') {
    return days <= EXPIRING_SOON_DAYS;
  }
  return false;
}

export function computeMonitorKpis(items: AdminSubscriptionMonitorItem[]): MonitorKpis {
  return {
    total: items.length,
    active: items.filter((i) => i.subscription_status === 'active').length,
    trialing: items.filter((i) => i.subscription_status === 'trialing').length,
    expiredOrSuspended: items.filter((i) =>
      ['expired', 'suspended', 'cancelled'].includes(i.subscription_status),
    ).length,
    paymentIssues: items.filter((i) => i.has_payment_issue).length,
    expiringSoon: items.filter(isExpiringSoon).length,
  };
}

export function formatDate(iso: string | null, locale: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatPaymentSummary(
  item: AdminSubscriptionMonitorItem,
  locale: string,
  formatStatus: (status: string) => string,
): string | null {
  if (!item.last_payment_status) return null;
  const parts: string[] = [formatStatus(item.last_payment_status)];
  if (item.last_payment_amount !== null && item.last_payment_currency) {
    parts.push(formatMoney(item.last_payment_amount, item.last_payment_currency, locale));
  }
  if (item.last_payment_provider_label) {
    parts.push(item.last_payment_provider_label);
  }
  return parts.join(' · ');
}
